module.exports = __webpack_public_path__ + "img/profile.581cc389.svg";